<div class="admin-layout">
  <app-side-bar></app-side-bar>
  <div class="admin-layout__body"
       [class.sidebar-collapsed]="sidebar.collapsed()"
       [class.sidebar-expanded]="!sidebar.collapsed()">
    <app-top-bar></app-top-bar>
    <main class="admin-layout__content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
